export default () =>{
    const accordionToggle = document.querySelectorAll('.accordions .faq-title');
    const accordionDescription = document.querySelectorAll('.accordions .description');
    const shownDescription = document.querySelector('.accordions .description.shown')
    
    if(!accordionToggle || !shownDescription) return;
    console.log(accordionToggle)
    const closeAllAccordions = () =>{
        accordionDescription.forEach(item=>{
            item.classList.remove('shown')
            item.style.maxHeight = 0
            item.style.padding = "0 3.5rem"
            if(isMobile())  item.style.padding = "0 1rem"
           
        })
        accordionToggle.forEach(item=>{
            item.classList.remove('active')
            item.querySelector('.title .plus').classList.remove('hide')
            item.querySelector('.title .minus').classList.add('hide')
        })
    }
    

    shownDescription.style.maxHeight = (shownDescription.scrollHeight+20) + 'px'
    shownDescription.style.padding = "1rem 3.5rem 1rem 3.5rem"
    if(isMobile()) shownDescription.style.padding = "1rem"
    shownDescription.style.margin = "1rem 0"
    accordionToggle.forEach(item=>{
        if(item.classList.contains('active')){
            item.querySelector('.title .plus').classList.toggle('hide')
            item.querySelector('.title .minus').classList.toggle('hide')
        }
        item.querySelector('.title').addEventListener('click', e=>{
            e.stopPropagation()
            e.preventDefault()
            
            closeAllAccordions()
            // Expand Description
            let target = document.querySelector(`#${e.target.dataset.target}`)
            let height = target.scrollHeight
            target.style.maxHeight = (height + 20 )+'px'
            target.style.padding = "1rem 3.5rem 1rem 3.5rem"
            if(isMobile()) target.style.padding = "1rem"
            target.style.margin = "1rem 0"
            target.classList.toggle('shown')
            item.querySelector('.title .plus').classList.toggle('hide')
            item.querySelector('.title .minus').classList.toggle('hide')
            item.classList.toggle('active')
        })
    })
}